import { KpiDelta } from '../badges/KpiDelta';
import { Sparkline } from '../charts/Sparkline';

import type { KpiVM } from '../../view-models';
import type React from 'react';

export interface KpiCardProps {
  kpi: KpiVM;
  onClick?: () => void;
}

export function KpiCard({ kpi, onClick }: KpiCardProps): React.JSX.Element {
  const cls = [
    'kpi-card',
    kpi.tone !== undefined && kpi.tone !== 'neutral' && `kpi-card--${kpi.tone}`,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={cls} onClick={onClick} aria-label={kpi.label}>
      <div className="kpi-card__head">
        <span className="kpi-card__label">{kpi.label}</span>
      </div>
      <div
        className={
          kpi.valueCompact === true ? 'kpi-card__value kpi-card__value--compact' : 'kpi-card__value'
        }
      >
        {kpi.value}
        {kpi.sub !== undefined && <span className="kpi-card__value-sub">{kpi.sub}</span>}
      </div>
      {kpi.descriptor !== undefined && <div className="kpi-card__descriptor">{kpi.descriptor}</div>}
      {kpi.placeholderNote !== undefined && (
        <div className="kpi-card__placeholder">{kpi.placeholderNote}</div>
      )}
      {kpi.delta !== undefined && (
        <div className="kpi-card__delta">
          <KpiDelta
            value={kpi.delta}
            {...(kpi.deltaTrend !== undefined ? { trend: kpi.deltaTrend } : {})}
          />
        </div>
      )}
      {kpi.spark !== undefined && (
        <div className="kpi-card__spark">
          <Sparkline
            data={kpi.spark}
            color={
              kpi.tone === 'danger'
                ? 'var(--danger-fg)'
                : kpi.tone === 'warning'
                  ? 'var(--warning-fg)'
                  : kpi.tone === 'success'
                    ? 'var(--success-fg)'
                    : kpi.tone === 'ai'
                      ? 'var(--ai-fg)'
                      : 'var(--brand)'
            }
            width={60}
            height={18}
          />
        </div>
      )}
    </button>
  );
}
